var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27.857,
    viewBox: "0 0 30 27.857",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.223 25.684a1.435 1.435 0 0 1-1.518.228 1.437 1.437 0 0 1-.848-1.279v-3.204A2.856 2.856 0 0 1 0 18.571v-10a2.857 2.857 0 0 1 2.857-2.857h15.714a2.858 2.858 0 0 1 2.858 2.857v10a2.858 2.858 0 0 1-2.858 2.858h-7.138l-6.21 4.255ZM22.857 14.31a9.26 9.26 0 0 0 0 .527v-.528c.007-.153.009-2.068.006-5.742a4.285 4.285 0 0 0-4.286-4.281H7.143V2.857A2.856 2.856 0 0 1 10 0h15.714a2.858 2.858 0 0 1 2.857 2.857v10a2.857 2.857 0 0 1-2.857 2.857v3.205a1.425 1.425 0 0 1-.848 1.278 1.426 1.426 0 0 1-1.517-.227l-.492-.337V14.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/Active.fb9b74ace913e5b76e47cd03d50c0cb1.svg";
export { ForwardRef as ReactComponent };